
import { isArray } from 'lodash';
import {remove as removeDiacritics} from 'diacritics';

import {
    REQUEST_FILTER_TRAT_LIST,
    REQUEST_GET_TRAT_LIST,
    RESPONSE_FILTER_TRAT_LIST,
    RESPONSE_GET_TRAT_LIST,
    SET_FILTER
} from '../actions/TratList';

const initialState = {
    data: {},
    filter: {
        filterId: [],
        loading: false
    },
    loading: false,
    initialized: false
};

function compareTextWithFilter(text, filterValue) {
    return (removeDiacritics(text).indexOf(removeDiacritics(filterValue)) !== -1);
}

function correspondFilterText(item, filter, attribute) {
    let text = item[attribute].toLowerCase();
    let correspond = true;
    if (filter[attribute]) {
        let filterValue = filter[attribute].toLowerCase();
        correspond =
            (compareTextWithFilter(text, filterValue));
    }
    return correspond;
}

function correspondFilterTratId(item, filter) {
    let correspond = true;
    if (isArray(filter.filterId.tratId)) {
        correspond = (filter.filterId.tratId.indexOf(parseInt(item.id)) !== -1);
    }
    return correspond;
}

export function getFilteredTratList(state) {
    let items = [];
    if (state.data.items) {
        items = state.data.items.filter(item => {
            let correspond = true;
            correspond = correspond && correspondFilterText(item, state.filter, 'podoblast');
            correspond = correspond && correspondFilterText(item, state.filter, 'obec');
            correspond = correspond && correspondFilterText(item, state.filter, 'katastr');
            correspond = correspond && correspondFilterText(item, state.filter, 'trat');
            correspond = correspond && correspondFilterTratId(item, state.filter);
            return correspond;
        });
    }
    return items;
}

export default function tratList(state = initialState, action) {
    switch (action.type) {
        case REQUEST_FILTER_TRAT_LIST:
            return {
                ...state,
                filter: {
                    ...state.filter,
                    //filterId: [],
                    loading: true
                }
            };

        case REQUEST_GET_TRAT_LIST:
            return {
                ...state,
                data: {},
                loading: true
            };

        case RESPONSE_FILTER_TRAT_LIST:
            return {
                ...state,
                filter: {
                    ...state.filter,
                    filterId: action.data,
                    loading: false
                }
            };

        case RESPONSE_GET_TRAT_LIST:
            return {
                ...state,
                initialized: true,
                data: action.data,
                loading: false
            };

        case SET_FILTER:
            return {
                ...state,
                filter: {
                    ...state.filter,
                    [action.attributeId]: action.attributeValue
                }
            }

        default:
            return state
    }
}
